<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill">
    <input matInput [matDatepicker]="picker" placeholder="Select Date" [formControl]="inactivationDateControl" [max]="maxDate" readonly />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="inactivationDateControl.hasError('required')">
      Please select a date
    </mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
  <button mat-button class="btn btn-primary" (click)="onSubmit()" [disabled]="inactivationDateControl.invalid">
    Submit
  </button>
</mat-dialog-actions>
